module.exports = __webpack_public_path__ + "img/white_star.9372b17a.svg";